/* Hamakija — FAQ (sections/hk-faq.liquid): live search, category chips (scroll-spy or filter). */
(() => {
  if (customElements.get('hk-faq')) return;
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l').replace(/\s+/g, ' ').trim();

  class HkFaq extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode === 'filter' ? 'filter' : 'scroll';
      this.chips = [...this.querySelectorAll('[data-hk-faq-chip]')];
      this.groups = [...this.querySelectorAll('[data-hk-faq-group]')];
      this.items = [...this.querySelectorAll('[data-hk-faq-item]')];
      this.empty = this.querySelector('[data-hk-faq-empty]');
      this.search = this.querySelector('[data-hk-faq-search]');
      this.items.forEach((d) => { d.dataset.hkText = norm(d.textContent); });

      this.chips.forEach((chip) => chip.addEventListener('click', (e) => this.onChip(e, chip)));
      if (this.search) {
        this.search.addEventListener('input', () => this.filter());
        this.search.addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
      }
      if (this.mode === 'filter' && this.chips.length) this.showGroup(this.chips[0].dataset.hkFaqChip);
      if (this.mode === 'scroll' && this.chips.length && 'IntersectionObserver' in window) this.spy();
      this.openFromHash();
    }

    setActive(id) {
      this.chips.forEach((c) => {
        const on = c.dataset.hkFaqChip === id;
        c.classList.toggle('is-active', on);
        if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
    }

    onChip(e, chip) {
      const id = chip.dataset.hkFaqChip;
      this.setActive(id);
      if (this.mode === 'filter') {
        e.preventDefault();
        if (this.search && this.search.value) { this.search.value = ''; this.filter(); }
        this.showGroup(id);
        return;
      }
      // scroll mode: smooth jump handled by the anchor; pause the spy so the clicked chip stays active
      this.lock = Date.now();
      if (this.search && this.search.value) { this.search.value = ''; this.filter(); }
    }

    showGroup(id) {
      this.groups.forEach((g) => { g.hidden = g.dataset.hkFaqGroup !== id; });
    }

    spy() {
      const io = new IntersectionObserver((entries) => {
        if (this.lock && Date.now() - this.lock < 900) return;
        const visible = entries.filter((en) => en.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length) this.setActive(visible[0].target.dataset.hkFaqGroup);
      }, { rootMargin: '-15% 0px -60% 0px' });
      this.groups.forEach((g) => io.observe(g));
    }

    filter() {
      const q = norm(this.search.value);
      let shown = 0;
      if (!q) {
        this.items.forEach((d) => { d.hidden = false; });
        if (this.mode === 'filter') {
          const active = this.chips.find((c) => c.classList.contains('is-active')) || this.chips[0];
          if (active) this.showGroup(active.dataset.hkFaqChip); else this.groups.forEach((g) => { g.hidden = false; });
        } else this.groups.forEach((g) => { g.hidden = false; });
        if (this.empty) this.empty.hidden = true;
        return;
      }
      const words = q.split(' ');
      this.items.forEach((d) => {
        const ok = words.every((w) => d.dataset.hkText.includes(w));
        d.hidden = !ok;
        if (ok) shown += 1;
      });
      this.groups.forEach((g) => { g.hidden = !g.querySelector('[data-hk-faq-item]:not([hidden])'); });
      if (this.empty) this.empty.hidden = shown > 0;
    }

    openFromHash() {
      const h = decodeURIComponent(window.location.hash || '').slice(1);
      if (!h) return;
      const target = document.getElementById(h);
      if (target && target.matches('[data-hk-faq-item]')) target.open = true;
    }
  }
  customElements.define('hk-faq', HkFaq);
})();
